function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/pickers/~/@babel/runtime/helpers/nonIterableRest.js
// module id = 1137
// module chunks = 0